import { Divider, Button, Box, Text, Stack, Flex, IconButton } from "@chakra-ui/core";
import React, { useContext } from "react";
import { formatPrice } from "utils/shared/prices";

import { ContextStore } from "context/ContextStore";
import useWindowSize from "hooks/useWindowSize";

import PencilAlt from "svg/icons/pencil-alt.svg";

const OrderItem = ({ price, order, index, ...props }) => {
  const { basketOrders, setBasketOrders, setOpenFood, setBasketOpen, isModalOpen, setModalOpen } = useContext(
    ContextStore
  );

  const deleteOrder = (index) => {
    const newBasketOrders = [...basketOrders];
    newBasketOrders.splice(index, 1);
    setBasketOrders(newBasketOrders);
  };

  const windowSize = useWindowSize();

  const handleOpen = (food, index) => {
    // JSON thingy to make a deep copy
    setOpenFood(JSON.parse(JSON.stringify({ ...food, index })));

    windowSize.width < 768 && setBasketOpen(false);

    setModalOpen(true);
  };

  // Handles the order quantity
  const handleQuantity = (amount, order, index) => {
    if (order.quantity >= 1 && amount > 0 && order.quantity < 99) {
      const newBasketOrders = [...basketOrders];
      newBasketOrders[index] = { ...order, quantity: order.quantity + amount };
      setBasketOrders(newBasketOrders);
    } else if (order.quantity > 1 && amount < 0) {
      const newBasketOrders = [...basketOrders];
      newBasketOrders[index] = { ...order, quantity: order.quantity + amount };
      setBasketOrders(newBasketOrders);
    }
  };

  return (
    <>
      {index !== 0 && <Divider mb="6" />}
      <Flex mb="6" alignItems="baseline" justifyContent="center">
        <Box flexShrink="0">
          <Stack isInline spacing="0">
            <Button rounded="full" size="xs" onClick={() => handleQuantity(-1, order, index)}>
              -
            </Button>
            <Flex h="6" w="6" fontSize="sm" fontWeight="semibold" bg="white" align="center" justify="center">
              {order.quantity}
            </Flex>
            <Button rounded="full" size="xs" onClick={() => handleQuantity(+1, order, index)}>
              +
            </Button>
          </Stack>

          <Button
            variantColor="brand"
            variant="outline"
            size="xs"
            fontSize="8px"
            rounded="full"
            fontWeight="bold"
            aria-label="Modifier"
            onClick={() => handleOpen(order, index)}
            p="1"
            mt="2"
            w="full"
            textTransform="uppercase"
            display="flex"
            alignItems="center"
            justifyContent="center"
            lineHeight="1"
          >
            <Box as={PencilAlt} size="14px" aria-label="Modifier" mr="1" />
            Modifier
          </Button>
        </Box>
        <Box flexShrink="1" mx="4" flexGrow="1">
          <Text fontSize="md" fontWeight="semibold" color="gray.800">
            {order.name}
            <IconButton
              variantColor="red"
              variant="ghost"
              size="xs"
              aria-label="Modifier"
              icon="delete"
              onClick={() => deleteOrder(index)}
              ml="2"
              mt="-2px"
            />
          </Text>
          <Box mt="2">
            {order.options &&
              order.options.map((option) => (
                <Box key={option.name}>
                  {option.optionItems.filter((item) => item.checked).length > 0 && (
                    <Text fontSize="sm" key={option.name} fontWeight="semibold" color="gray.700" mt="2">
                      {option.name}
                    </Text>
                  )}
                  {option.optionItems
                    .filter((item) => item.checked)
                    .map((item) => (
                      <Text fontSize="sm" key={item.name} fontWeight="normal" color="gray.600">
                        {item.name} {item.price > 0 ? `(+${formatPrice(item.price)})` : null}
                        {item.price < 0 ? `(${formatPrice(item.price)})` : null}
                      </Text>
                    ))}
                </Box>
              ))}
            {order.comments && (
              <Box>
                <Text fontSize="sm" fontWeight="semibold" color="gray.700" mt="2">
                  Commentaire
                </Text>
                <Text fontSize="sm" fontWeight="normal" color="gray.600">
                  {order.comments}
                </Text>
              </Box>
            )}
          </Box>
        </Box>
        <Box flexShrink="0">
          <Text fontSize="md" fontWeight="normal" color="gray.700">
            {formatPrice(price)}
          </Text>
        </Box>
      </Flex>
    </>
  );
};

export default OrderItem;
